import { t } from 'i18next'
import React from 'react'
import { ButtonWhite } from '../../Buttons/ButtonWhite'
import { ButtonWhiteTwo } from '../../Buttons/ButtonWhiteTwo'
import { CustomModal } from '../../CustomModal/CustomModal'
import camaraIcon from '../../../assets/icons/camara.svg'
const ScanInputPermissionsModal = ({ showModal, setShowModal, message, onClick, closeButtonText }) => {

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            centered
            size='sm'
        >
            <div className="d-flex flex-column justify-content-center align-items-center text-center gap-3">
                <img
                    src={camaraIcon}
                    alt=""
                />
                <p>{message}</p>
            </div>
            <div className='d-flex text-center'>
                <ButtonWhite onClick={setShowModal}>
                    {closeButtonText}
                </ButtonWhite>
                {
                    onClick ?
                        <ButtonWhiteTwo
                            onClick={() => {
                                onClick();
                                setShowModal();
                            }}
                        >
                            {t('ALLOW_USE')}
                        </ButtonWhiteTwo>
                        :
                        null
                }
            </div>
        </CustomModal>
    )
}

export default ScanInputPermissionsModal